import {Injectable} from "@angular/core";
import {Receipt} from "../types/receipt";
import {UtilsService} from "./utils";
import "km-nets-smartpos";
import {Plugins} from "@capacitor/core";
import {ConfigurationService} from "./configuration";
import {Printer} from "../types/printer";
import {Observable, Subscriber} from "rxjs";
import {BestoranteService} from "./bestorante";
import { RestolutionService } from "./restolution";
import { Logger, LoggingService } from "ionic-logging-service";
// eslint-disable-next-line @typescript-eslint/naming-convention
const {NetsSmartPos} = Plugins;

@Injectable({
  providedIn: "root"
})
export class PrintServiceNets implements Printer {

  private logger: Logger;

  constructor(private utils: UtilsService, private conf: ConfigurationService, private besto: BestoranteService,
    private resto: RestolutionService, private loggingService: LoggingService) {
      this.logger = loggingService.getLogger("BestoGo.PrintServiceNets");
  }

  print(receipt: Receipt): Observable<string> {
    const pr = new Observable((observer: Subscriber<string>) => {
      const printOpts = {
        lines: []
      };
      const output = receipt.printOut ? receipt.printOut.split("\n\r") : this.utils.rowsToReceipt(receipt,
        receipt.rows, 30, receipt.date, receipt.number, this.conf.confData, null, this.besto.restaurant,
        receipt.clerkID ? receipt.clerkID : null);
      this.logger.debug("print", "Formatted rows", output);
      for (const o of output) {
        printOpts.lines.push({
          text: o
        });
      }
      printOpts.lines.push({text: " "});
      receipt.printOut = output.join("\n\r");
      if (this.conf.getPlatform() === "ios") {
        this.logger.error("print", "iOS printing not supported", receipt);
        observer.next(receipt.printOut);
        observer.complete();
        return;
      }
      NetsSmartPos.print(printOpts).then((a) => {
        this.logger.debug("print", "Got back", a);
      });
      observer.next(receipt.printOut);
      return {
        unsubscribe: () => {
        }
      };
    });
    return pr;
  }

  printSlip(activeReceipt: Receipt, copy?: boolean): Observable<string> {
    const pr = new Observable((observer: Subscriber<string>) => {
      if (!copy) {
        copy = false;
      }
      if (this.conf.getPlatform() === "ios") {
        this.logger.error("printSlip", "iOS printSlip not supported", activeReceipt);
        return;
      }
      for (const p of activeReceipt.payments) {
        NetsSmartPos.printSlip({paymentUuid: p.cardTerminalTransactionId, copy}).then((a) => {
          this.logger.debug("printSlip", "Slip printed", a);
        });
      }
      observer.next(null);
    });
    return pr;
  }

}
